<section class="processing-fee-wrap">
  <div class="wrap-lg">
    <div class="processing-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="back()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="nav-name" >Back</span>
        </div>
      </div>
      <div class="page-head">
        <div class="head-left">
          <div class="page-title">Processing Fee</div>
          <div class="page-info">Please select the mode of payment by which you would like to pay.</div>
        </div>
      </div>
      <div class="box-wrap fee-content">
        <div class="fee-inner">
          <div class="gradient-line"></div>
          <div class="fee-left">
            <img src="assets/images/dialog/processing_fee.svg" alt="Processing Fees"/>
          </div>
          <div class="fee-right">
            <div class="amount-info">Amount Payable</div>
            <div class="amount"><span class="lite"></span>{{util.loanDetails.processingFee | currency: 'INR': 'symbol':'1.2-2'}}</div>
            <div class="fee-action">
              <button class="btn-primary" (click)="redirectToPaymentGateway()">Continue</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>

<div [innerHTML]="sanitizedCampspayHtml" id="paymentGateway" ></div>

<iframe #campspayIframe width="0" height="0"></iframe>



